/**
 * Metric tone system — semantic color families for dashboard numbers.
 *
 * emerald = money in · orange = money out/spend · amber = credits (gold)
 * violet = profit/margin · blue = players/network · rose = risk & attention
 * slate  = neutral snapshots
 *
 * Flat 2D surfaces (no gradients/shadows). Class strings are literal for Tailwind.
 */
export const TONE_STYLES = {
    emerald: {
        surface: 'bg-emerald-50/50',
        chipBg: 'bg-emerald-100',
        chipText: 'text-emerald-700',
        value: 'text-emerald-800',
        wash: 'bg-emerald-50',
    },
    orange: {
        surface: 'bg-orange-50/50',
        chipBg: 'bg-orange-100',
        chipText: 'text-orange-700',
        value: 'text-orange-800',
        wash: 'bg-orange-50',
    },
    amber: {
        surface: 'bg-amber-50/50',
        chipBg: 'bg-amber-100',
        chipText: 'text-amber-700',
        value: 'text-amber-800',
        wash: 'bg-amber-50',
    },
    violet: {
        surface: 'bg-violet-50/50',
        chipBg: 'bg-violet-100',
        chipText: 'text-violet-700',
        value: 'text-violet-800',
        wash: 'bg-violet-50',
    },
    blue: {
        surface: 'bg-blue-50/50',
        chipBg: 'bg-blue-100',
        chipText: 'text-blue-700',
        value: 'text-blue-800',
        wash: 'bg-blue-50',
    },
    rose: {
        surface: 'bg-rose-50/50',
        chipBg: 'bg-rose-100',
        chipText: 'text-rose-700',
        value: 'text-rose-800',
        wash: 'bg-rose-50',
    },
    slate: {
        surface: 'bg-gray-50/60',
        chipBg: 'bg-gray-100',
        chipText: 'text-gray-600',
        value: 'text-gray-900',
        wash: 'bg-gray-50',
    },
};
export function toneStyle(tone) {
    return TONE_STYLES[tone || 'slate'];
}
/** Chart series colors — flat palette aligned with metric tones. */
export const CHART_SEMANTIC = {
    moneyIn: '#1baf7a',
    moneyOut: '#eb6834',
    players: '#2a78d6',
    counterOut: '#e87ba4',
    credits: '#d97706',
    profit: '#4a3aa7',
};
